/**
 * Parse date string to Date object, returning null for invalid dates
 * @param str - Date string to parse
 * @returns Date object or null if invalid
 */
export const parseDate = (str?: string): Date | null => {
  if (!str?.trim()) return null;
  const date = new Date(str);

  return Number.isNaN(date.getTime()) ? null : date;
};
